// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_t0-0";